import { SelectableFilterQueryBase } from "../../common/selectableFilterQueryBase";

export enum ProductsSearchManagedStockFilterType {
    Mark,
    Exclude,
    Only
}

export interface ProductsSearchFilterQuery extends SelectableFilterQueryBase {
    keyword?: string;
    contains?: boolean;
    stockIds?: string[];
    loadPdes?: boolean;
    loadApns?: boolean;
    searchPdes?: boolean;
    searchBarcodes?: boolean;
    ethical?: boolean | null;
    pbs?: boolean | null;
    schedule?: string;
    hasGenericCategory?: boolean | null;
    genericCategoryIds?: string[];
    supplierCodes?: string[];
    fromCreatedDate?: string | null;
    toCreatedDate?: string | null;

    storeGroupIds?: number[]
    managedStockFilterType?: ProductsSearchManagedStockFilterType;

    columnSearchType?: ProductSearchColumnSearchType;

}

export enum ProductSearchColumnSearchType {
    Search,
    QuickSearch
}
